module.exports = __webpack_public_path__ + "img/add.58912e07.png";